//校验名称的正则
export function nameValidator(rule, value, callback) {
  if (value && value.length > 0) {
    if (/^(?!_)(?!.*?_$)(.*$)+$/.test(value)) {
      if (value.length > 50) {
        callback('不能超过50个字符');
      }
    } else {
      callback('不能以下划线开头和结尾')
    }
  }
  callback()
};

//校验座机号码的正则
export function checkTel(rule, value, callback) {
  const vaReg = /^\s*\+?\s*(\(\s*\d+\s*\)|\d+)(\s*-?\s*(\(\s*\d+\s*\)|\s*\d+\s*))*\s*$/;
  if (value) {
    if (vaReg.test(value)) {
      if (value.length > 20) {
        callback('号码长度超过20个字符');
      } else {
        callback();
      }
    } else {
      callback('号码格式错误');
    }
  }
  callback();
};

//校验二十位以内数字的正则
export function checkNumber(rule, value, callback) {
  if (value) {
    const s = value.toString();
    if (s.charAt(0).match(/0|-|#/)) {
      callback('只支持十进制非负数数字');

    } else if (s.length > 20) {
      callback('最多20位数字');
    } else {
      callback();
    }
  }
  callback();
};

//校验整数正则
export function checkInteger(rule, value, callback) {
  const vaReg = /^\d{1,}$/;
  if (value) {
    if (!(vaReg.test(value))) {
      callback('排序只可输入整数');
    }
    callback();
  }
  callback();
};

//校验手机号码的正则
export function checkPhone(rule, value, callback) {
  const vaReg = /^((\+?86)|(\(\+86\)))?1\d{10}$/;
  if (!value || (value && !vaReg.test(value))) {
    callback('请输入正确的手机号码');
  } else {
    callback();
  }
};

//校验微信号的正则
export function checkWeiXin(rule, value, callback) {
  if (value && value.length > 0) {
    if (/^\w+$/.test(value)) {
      if (value.length > 30) {
        callback('不能超过30个字符')
      } else {
        callback()
      }
    } else {
      callback('微信账号由数字、26个英文字母或者下划线组成')
    }
  }
  callback()
};

//校验QQ号的正则
export function checkQQ(rule, value, callback) {
  if (value && value.length > 0) {
    if (/^[1-9][0-9]{4,9}$/.test(value)) {
      callback()
    } else {
      callback('QQ号不合法')
    }
  }
  callback()
};

//校验手动输入编码的正则
export function checkCode(rule, value, callback) {
  const vaReg = /^(?!_)(?!.*?_$)\w{1,20}$/;
  if (value) {
    if (!(vaReg.test(value))) {
      callback('请输入1-20位的数字、字母或下划线,但不可用下划线开头和结尾');
    }
    callback();
  }
  callback();
}

//校验Value的正则
export function checkValue(rule, value, callback) {
  const vaReg = /^[a-zA-Z0-9.]+$/;
  if (value) {
    if (!(vaReg.test(value))) {
      callback('只可输入数字、字母及小数点');
    }
    callback();
  }
  callback();
}

function isConsecutiveDigitSequence(sequence) {
  if (!/^\d+$/.test(sequence) || sequence.length < 3) {
    return false;
  }
  let ascending = true;
  let descending = true;
  for (let i = 1; i < sequence.length; i++) {
    const prev = parseInt(sequence[i - 1], 10);
    const current = parseInt(sequence[i], 10);
    if (current - prev !== 1) {
      ascending = false;
    }
    if (prev - current !== 1) {
      descending = false;
    }
  }
  return ascending || descending;
}

export function hasConsecutiveDigits(password, minLength = 5) {
  if (!password) {
    return false;
  }
  for (let i = 0; i <= password.length - minLength; i++) {
    const slice = password.slice(i, i + minLength);
    if (isConsecutiveDigitSequence(slice)) {
      return true;
    }
  }
  return false;
}

export function getPasswordStrengthMessage(password) {
  if (!password) {
    return '';
  }
  if (password.length < 6) {
    return '密码长度最少6位';
  }
  if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) {
    return '密码须同时包含字母和数字';
  }
  if (hasConsecutiveDigits(password)) {
    return '密码不能包含连续数字';
  }
  return '';
}

export function passwordStrengthValidator(rule, value, callback) {
  if (!value) {
    callback();
    return;
  }
  const message = getPasswordStrengthMessage(value);
  if (message) {
    callback(message);
  } else {
    callback();
  }
}

export function newPasswordNotSameValidator(getOriginPassword) {
  return (rule, value, callback) => {
    if (!value) {
      callback();
      return;
    }
    const originPassword = getOriginPassword();
    if (originPassword && value.toUpperCase() === originPassword.toUpperCase()) {
      callback('新密码不能与原密码相同');
      return;
    }
    callback();
  };
}






// WEBPACK FOOTER //
// ./src/utils/regexp.js